/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ListFilterPlus = [
  ["path", { d: "M12 5H2" }],
  ["path", { d: "M6 12h12" }],
  ["path", { d: "M9 19h6" }],
  ["path", { d: "M16 5h6" }],
  ["path", { d: "M19 8V2" }]
];

export { ListFilterPlus as default };
//# sourceMappingURL=list-filter-plus.js.map
